import { NOTIFICATIONS_SPRINT_RULES } from '@lingoda/notifications';
import setNotificationValue from './setNotificationValue';

export default () =>
    setNotificationValue({
        notification: NOTIFICATIONS_SPRINT_RULES,
        value: '0',
    });
